import request from '@/utils/request'

// 查询【我关注的客户】列表
export function addListCust(query) {
  return request({
    url: '/scrm/customer/selectAddList',
    method: 'get',
    params: query
  })
}

export function listCust(query) {
  return request({
    url: '/scrm/customer/list',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '数据获取中'
    }
  })
}

// 查询【我关注的客户】详细
export function getCust(custId) {
  return request({
    url: '/scrm/customer/' + custId,
    method: 'get',
    options: {
      loading: true,
      loadingText: '数据获取中'
    }
  })
}

// 新增【我关注的客户】
export function addCust(data) {
  return request({
    url: '/scrm/customer',
    method: 'post',
    data: data
  })
}
// 新增回访记录
export function addVisit(data) {
  return request({
    url: '/scrm/visit',
    method: 'post',
    data: data
  })
}

// 修改【我关注的客户】
export function updateCust(data) {
  return request({
    url: '/scrm/customer',
    method: 'put',
    data: data
  })
}

// 商机
export function listBo(query) {
  return request({
    url: '/scrm/bo/list',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '数据获取中'
    }
  })
}
export function getBo(id) {
  return request({
    url: '/scrm/bo/' + id,
    method: 'get'
  })
}
export function selectContByBoId(query) {
  return request({
    url: '/cont/newContract/list',
    method: 'get',
    params: query,
    options: {
      loading: true
    }
  })
}

export function delBo(id) {
  return request({
    url: '/scrm/bo/' + id,
    method: 'delete'
  })
}
export function addBo(data) {
  return request({
    url: '/scrm/bo',
    method: 'post',
    data: data
  })
}
export function updateBo(data) {
  return request({
    url: '/scrm/bo',
    method: 'put',
    data: data
  })
}
// 商机阶段
export function getAllStage() {
  return request({
    url: '/scrm/stage/getAllList',
    method: 'get'
  })
}
// 商机-产品信息
export function listProduct(query) {
  return request({
    url: '/scrm/product/list',
    method: 'get',
    params: query
  })
}
// 获取经纬度
export function getDistrict(id) {
  return request({
    url: '/system/district/' + id,
    method: 'get'
  })
}
// 申请共享客户信息
export function batchApplyShare(data) {
  return request({
    url: '/scrm/share/batchApplyShare',
    method: 'post',
    data: data
  })
}
export function addApply(data) {
  return request({
    url: '/scrm/apply',
    method: 'post',
    data: data
  })
}
export function listApply(query) {
  return request({
    url: '/scrm/apply/list',
    method: 'get',
    params: query
  })
}
// 获取公海信息
export function getApply(highSeasApplyId) {
  return request({
    url: '/scrm/apply/' + highSeasApplyId,
    method: 'get'
  })
}
export function auditApply(data) {
  return request({
    url: '/scrm/apply/batchApproval',
    method: 'post',
    data: data
  })
}
// 共享审核
export function batchApproval(data) {
  return request({
    url: '/scrm/share/batchApproval',
    method: 'post',
    data: data
  })
}
export function listShare(query) {
  return request({
    url: '/scrm/share/list',
    method: 'get',
    params: query
  })
}
// 获取共享信息
export function getShare(customerShareId) {
  return request({
    url: '/scrm/share/' + customerShareId,
    method: 'get'
  })
}
// 获取标签
export function tagList(data) {
  return request({
    url: 'system/tagGroup/listByTagGroup',
    method: 'post',
    data
  })
}
// 获取我的客户筛选总数
export function getMyCustomerCount(query) {
  return request({
    url: '/scrm/customer/getCountItem',
    method: 'get',
    params: query
  })
}
// 获取我的商机筛选总数
export function getBusinessCount(query) {
  return request({
    url: '/scrm/bo/getCountItem',
    method: 'get',
    params: query
  })
}
// 关注商机
export function listStar(query) {
  return request({
    url: '/scrm/bo/selectCrmBoByTeam',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '数据获取中'
    }
  })
}
// 获取公海客户列表
export function getPublicCustomerList(query) {
  return request({
    url: '/scrm/customer/selectHighSeasCustomerList',
    method: 'get',
    params: query
  })
}
// 获取公海客户筛选总数
export function getPublicCustomerCount(query) {
  return request({
    url: '/scrm/customer/getCountHighSeasItem',
    method: 'get',
    params: query
  })
}
// 本月成功申领的个数
export function getMonthlyApplyCount(data) {
  return request({
    url: '/scrm/apply/successApproval',
    method: 'post',
    data: data
  })
}

// 获取客户来源树数据
export function getSourceTree() {
  return request({
    url: '/scrm/source/list',
    method: 'get'
  })
}

// 查询客户操作日志列表
export function getCustomerLogList(query) {
  return request({
    url: '/scrm/log/listNotPage',
    method: 'get',
    params: query
  })
}

// 查询【客户继承日志】列表
export function getCustomerInheritLogList(query) {
  return request({
    url: '/scrm/inheritLog/list',
    method: 'get',
    params: query
  })
}

// 企业微信获取客户列表
export function selectAddListWx(query) {
  return request({
    url: '/scrm/customer/selectAddListWx',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '数据导入中'
    }
  })
}

// 企业微信获取客户列表
export function getWxLoadList(query) {
  return request({
    url: '/scrm/wxload/list',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '数据同步中'
    }
  })
}

// 查询供应商信息信息列表
export function listSupplier(query) {
  return request({
    url: '/scrm/sup/list',
    method: 'get',
    params: query
  })
}
// 获取供应商信息信息详细信息
export function getSupplier(custId) {
  return request({
    url: '/scrm/sup/' + custId,
    method: 'get'
  })
}
// 新增供应商信息信息
export function addSupplier(data) {
  return request({
    url: '/scrm/sup',
    method: 'post',
    data: data
  })
}
// 修改供应商信息信息
export function updateSupplier(data) {
  return request({
    url: '/scrm/sup',
    method: 'put',
    data: data
  })
}
// 删除供应商信息信息
export function deleteSupplier(custId) {
  return request({
    url: '/scrm/sup/' + custId,
    method: 'delete'
  })
}
// 查询供应商产品类型列表
export function listSubProduct(query) {
  return request({
    url: '/scrm/subProduct/list',
    method: 'get',
    params: query
  })
}
